/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_StartInputs */

const en_us2_history_transfer_start = /** @type {(inputs: History_Transfer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const pt_br2_history_transfer_start = /** @type {(inputs: History_Transfer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

const es_419_history_transfer_start = /** @type {(inputs: History_Transfer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

const pt_pt2_history_transfer_start = /** @type {(inputs: History_Transfer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

const fr_fr2_history_transfer_start = /** @type {(inputs: History_Transfer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer`)
};

const de_de2_history_transfer_start = /** @type {(inputs: History_Transfer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importieren`)
};

const it_it2_history_transfer_start = /** @type {(inputs: History_Transfer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa`)
};

/**
* | output |
* | --- |
* | "Import" |
*
* @param {History_Transfer_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_start = /** @type {((inputs?: History_Transfer_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_start(inputs)
	if (locale === "es-419") return es_419_history_transfer_start(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_start(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_start(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_start(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_start(inputs)
	return en_us2_history_transfer_start(inputs)
});
export { history_transfer_start as "history-transfer.start" }